// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/config/index.ts"
);
import.meta.hot.lastModified = "1771648988182.4778";
}
// REMIX HMR END

import { LngLatLike } from "mapbox-gl"
import { LangDat, SupportedLangs } from "~/types/sys"

const SYS_CONFIG = Object.freeze({
    URL_SITE_DOMAIN: 'https://inzh.ch',
    URL_BUCKET_DEV: 'http://localhost:3333/_static',
   // URL_BUCKET_PROD: 'https://odzh3staging-staticbucket-fulrmaqmfvbd.s3.eu-central-1.amazonaws.com',
//    URL_BUCKET_PROD: 'https://odzh3production-staticbucket-hiyru1yfxbif.s3.eu-central-1.amazonaws.com',
   // URL_BUCKET_PROD: 'https://odzh3production-staticbucket-hiyru1yfxbif.s3.eu-central-1.amazonaws.com',
    URL_BUCKET_PROD: 'https://inzh.ch/_static',

    SUPPORTED_LANGS: ["de", "en", "it", "fr"] as SupportedLangs[],
    SUPPORTED_LANG_OBJECTS: [
        {
            lang_code: "en",
            lang_html: "en-US",
            lang_param: "",
            default: true,
            label: "English"
        },
        {
            lang_code: "de",
            lang_html: "de-CH",
            lang_param: "de",
            default: false,
            label: "Deutsch"
        },
        {
            lang_code: "fr",
            lang_html: "fr-CH",
            lang_param: "fr",
            default: false,
            label: "Français"
        },
        {
            lang_code: "it",
            lang_html: "it-CH",
            lang_param: "it",
            default: false,
            label: "Italiano"
        }
    ] as LangDat[],
    ROUTE_FRAGMENTS: {
        RF_GUIDE: 'places',
        RF_ZUERICH: 'zuerich',
        RF_RAPPERSWIL_ZUERICHSEE: 'rapperswil-zuerichsee',
        RF_EYZ: 'einsiedeln',
        RF_KANTONSRAT: 'kantonsrat',
        RF_PERSONEN: 'personen',
        RF_PAGE: 'page',
        RF_MITGLIEDER: 'mitglieder',
        RF_FRAKTIONEN: 'fraktionen',
        RF_WAHLKREISE: 'wahlkreise',
        RF_KOMMISSIONEN: 'kommissionen',
        RF_SITZUNGEN: 'sitzungen',
        RF_GESCHAEFTE: 'geschaefte',
        RF_PRIVACY: 'privacy',
        RF_ABOUT: 'about',
        RF_NEWS: 'news',
    },
    MAPBOX: {
        TOKEN: "pk.eyJ1Ijoid2VuemYiLCJhIjoiY2xoeXYyZ3Q3MTdsaDNxbnQ3MzZxd2RlcCJ9.lbMum1VuwH5uRF0bJtMkkA",
        ZOOMS: {
            LOW: 9,
            MID: 11,
            HIGH: 14
        },
        PITCH: {
            FOR_LOW: 45,
            FOR_MID: 55,
            FOR_HIGH: 66
        },
        CORDS: {
            ZUERICH: [8.5417, 47.3769] as LngLatLike,
            RAPPERSWIL: [8.7061, 47.2791] as LngLatLike,
            EYZ: [8.4954, 47.1343] as LngLatLike
        }
    },
    LAYOUT: {
        GUIDE: {
            WIDTH_FEED: 380,
            WIDTH_ARTICLE: 512
        }
    },
    PAGE_HANDLES: {
        H_GUIDE: 'places',
        H_HOME: 'home',
        H_GUIDE_WITH_DATA: 'places_data',
        H_KANTONSRAT_PERSONEN_FEED: 'H_KANTONSRAT_PERSONEN_FEED',
        H_KANTONSRAT_PERSONEN_ITEM: 'H_KANTONSRAT_PERSONEN_ITEM',
        H_KANTONSRAT_MITGLIEDER_FEED: 'H_KANTONSRAT_MITGLIEDER_FEED',
        H_KANTONSRAT_MITGLIEDER_ITEM: 'H_KANTONSRAT_MITGLIEDER_ITEM',
        H_KANTONSRAT_FRAKTIONEN: 'H_KANTONSRAT_FRAKTIONEN',
        H_KANTONSRAT_WAHLKREISE: 'H_KANTONSRAT_WAHLKREISE',
        H_KANTONSRAT_KOMMISSIONEN: 'H_KANTONSRAT_KOMMISSIONEN',
        H_KANTONSRAT_SITZUNGEN_FEED: 'H_KANTONSRAT_SITZUNGEN_FEED',
        H_KANTONSRAT_SIZTUNGEN_ITEM: 'H_KANTONSRAT_SIZTUNGEN_ITEM',
        H_KANTONSRAT_GESCHAEFTE_FEED: 'H_KANTONSRAT_GESCHAEFTE_FEED',
        H_KANTONSRAT_GESCHAEFTE_ITEM: 'H_KANTONSRAT_GESCHAEFTE_ITEM',
        H_ABOUT: 'H_ABOUT',
        H_PRIVACY: 'H_PRIVACY',
        H_NEWS: 'H_NEWS',
        H_NEWS_ITEM: 'H_NEWS_ITEM'
    },

    SUB_CONF: {
        KANTONSRAT: {
            PERSONEN_FEED_ITEMS_PER_PAGE: 50
        }
    },

    CACHE_CONTROL: {
        "Cache-Control": `max-age=300`,
    }

})



export default SYS_CONFIG

